export const getPersistKey = (name = "", version = ""): string => {
  if (!name || !version) return "root";
  return `${name.replace(/\s/g, "_")}v${version}`;
};
